module.exports = __webpack_public_path__ + "img/medical_expenses_icon.ec9ec102.webp";